export class NumberHelper {
    static parseCurrency(text: string): number {
        return parseFloat(text.replace(/,/g, ''));
    }
}